'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z' });

var CropOriginal = function CropOriginal(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

CropOriginal = (0, _pure2.default)(CropOriginal);
CropOriginal.muiName = 'SvgIcon';

exports.default = CropOriginal;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/CropOriginal.js
// module id = 2294
// module chunks = 0